import { createFileRoute } from "@tanstack/react-router";

import { FeaturePage } from "@/components/site/FeaturePage";
import { featurePage } from "@/content/features";
import { normalizeLocale } from "@/lib/i18n";
import { pageHead } from "@/content/seo-pages";
import { faqScript } from "@/lib/faq-schema";

export const Route = createFileRoute("/{-$locale}/purchases")({
  staticData: { sitemap: true },
  head: ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const seo = featurePage("purchases").seo;
    const head = pageHead("/purchases", locale, { title: seo.title, description: seo.description });
    return { ...head, scripts: faqScript(featurePage("purchases").faq, locale) };
  },
  component: purchasesPage,
});

function purchasesPage() {
  return <FeaturePage content={featurePage("purchases")} />;
}
